<template>
  <hic-dialog append-to-body @open="page" :close-on-click-modal="false" :visible="visible" width="60rem" title="数据库链接"
    @close="cancel">
    <div style="padding: 0 1rem">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="create">新建</el-button>
      <el-table :data="entities.items" height="30rem" size="big">
        <el-table-column label="操作" prop="code">
          <template #default="{ row }">
            <el-button type="primary" size="mini" plain circle icon="el-icon-edit" @click="edit(row)" />
            <hic-regret-button type="danger" size="mini" class="left-pad" plain circle icon="el-icon-delete" :seconds="5"
              badge="success" @click="del(row)" />
            <el-button type="warning" size="mini" plain circle icon="el-icon-document-copy" class="left-pad" @click="copy(row)" />
          </template>
        </el-table-column>
        <el-table-column label="编码" prop="code" sortable></el-table-column>
        <el-table-column label="名称" prop="name" sortable></el-table-column>
        <el-table-column label="类型" prop="type" sortable>
          <template #default="{ row }">
            <el-tag type="primary" hit>{{ row.type }}</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="info" @click="$emit('update:visible', false)">关 闭</el-button>
    </div>
    <EditDlg v-model="entity" :visible.sync="showEditor" @saved="page()" />
  </hic-dialog>
</template>
<script>
import api from "./api";
import { mapGetters } from "sw-hic";
export default {
  props: {
    visible: Boolean,
  },
  components: {
    EditDlg: () => import("./dbEdit"),
  },
  data() {
    return {
      entities: { items: [] },
      entity: {},
      showEditor: false,
    };
  },
  computed: {
    ...mapGetters(["dict"]),
    treeData() {
      return this.sys?.curr?.treeData ?? [];
    },
    waitingSys() {
      return this.sys.items.filter((f) => f.selected === false);
    },
    selectedSys() {
      return this.sys.items.filter((f) => f.selected === true);
    },
  },
  mounted() {
    this.page();
  },
  methods: {
    page() {
      api.DbCon.query({
        pageIndexOnView: 1,
        pageSize: 999,
      })
        .then((res) => {
          this.entities = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cancel() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
    },
    create() {
      this.entity = {};
      this.showEditor = true;
    },
    edit(row) {
      this.entity = this.$utils.Obj.clone(row);
      this.showEditor = true;
    },
    del(row) { },
    copy(row) {
      this.entity = this.$utils.Obj.clone(row);
      delete this.entity.id
      this.showEditor = true;
    }
  },
};
</script>
<style>
.el-table .cell {
  padding: 10px;
}
</style>